import React, { useState } from 'react';
import './navbar.css';
import MENU from '../../assets/menubar.png'
import CLOSE from '../../assets/close-button.png'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (event, anchorId) => {
    event.preventDefault(); // Prevent the default anchor behavior
  
    const scrollToElement = document.getElementById(anchorId);
    if (scrollToElement) {
      const offset = window.innerWidth <= 768 ? -96 : 0; // Adjust 768px to your breakpoint; -80px for 5rem assuming 1rem = 16px
      const elementPosition = scrollToElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition + offset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  
    setIsMenuOpen(false); // Close the menu, assuming you have a responsive design
  };
  

  return (
    <nav className='nav'>
      <button className='menu-toggle' onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <img src={MENU} style={{height:"1.5rem", width:"auto"}} alt="Menu"/>
      </button>
      <a href='#' onClick={(e) => handleNavClick(e,'#')} className='site-title'>LIEW KAI LIN</a>

      <div className={`site-header ${isMenuOpen ? 'open' : ''}`}>
        <button className='menu-close' onClick={() => setIsMenuOpen(false)}>
          <img src={CLOSE} style={{height:"3.5rem", width:"auto"}} alt="Close"/>
        </button>

        <a href='#introduction' onClick={(e) => handleNavClick(e, 'introduction')} className='site-nav'>About Me</a>
        <a href='#awards' onClick={(e) => handleNavClick(e, 'awards')} className='site-nav'>Awards</a>
        <a href='#testimonials' onClick={(e) => handleNavClick(e, 'testimonials')} className='site-nav'>Testimonials</a>
        <a href='#contact' onClick={(e) => handleNavClick(e, 'contact')} className='site-nav'>Contact Me</a>

      </div>
    </nav>
  );
}

export default Navbar;
